var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.showLeft)?_c('ArrowNav',{attrs:{"type":"left"},on:{"on-click":function($event){return _vm.onClickLeft(true)}}}):_vm._e(),(_vm.showRight)?_c('ArrowNav',{attrs:{"type":"right"},on:{"on-click":function($event){return _vm.onClickRight(false)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }